<script>
    import Privacy from "../components/Privacy.svelte";
    import { onMount } from "svelte";
    import Historyback from "../components/Historyback.svelte";

    onMount(() => {
        window.scroll(0, 0);
    });
</script>    

<div class="flex jc-between">
    <h2>個人情報の取扱いについて</h2>
    <Historyback />
</div>
<Privacy />
<div class="flex jc-end">
    <Historyback />
</div>
